var _circle, _polyline, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaAvatarTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "AdA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#EDE9FE"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "22,68 39,49 54,58 73,33",
    fill: "none",
    stroke: "#0F172A",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 33,
    r: 11,
    fill: "#7C3AED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaAvatarTrend);
export default __webpack_public_path__ + "static/media/ada-avatar-trend.c588e7b46286146510aedc50210e01ba.svg";
export { ForwardRef as ReactComponent };